
import * as React from 'react';
//import "../Users&Roles/UsersTab.css";
import { styled } from '@mui/system';
import TabsUnstyled from '@mui/base/TabsUnstyled';
import TabsListUnstyled from '@mui/base/TabsListUnstyled';
import TabPanelUnstyled from '@mui/base/TabPanelUnstyled';
import { buttonUnstyledClasses } from '@mui/base/ButtonUnstyled';
import TabUnstyled, { tabUnstyledClasses } from '@mui/base/TabUnstyled';
import EmailTemplates from './EmailTemplates';
import EmailVendor from './EmailVendor/EmailVendor';
import { useLocation } from 'react-router-dom';
import { useGlobalComponent } from '../../../pages/commom/GlobalComponentProvider';
import { useEffect, useState } from 'react';
import { HasScreenPermissions } from '../../../utils/Token';
// import INFO from "../../utils/Enums.json";
import INFO from '../../../pages/commom/RouteUrlInfo.json';


const white = {
  50: '#fff',
  100: '#fff',
  200: '#fff',
  300: '#fff',
  400: '#fff',
  500: '#F2F4F7',
  600: '#030202',
  700: '#0059B2',
  800: '#fff',
  900: '#fff',
};

const Tab = styled(TabUnstyled)`
  font-family: IBM Plex Sans, sans-serif;
  color: black;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: bold;
  background-color: transparent;
  width: 100%;
  padding: 10px 5px;
  margin: 6px 6px;
  border: none;
  border-radius: 5px;
  display: flex;
  justify-content: center;

  &:hover {
    background-color: ${white[400]};
  }

  &:focus {
    color: #fff;
    border-radius: 3px;
    outline: 2px solid ${white[200]};
    outline-offset: 2px;
  }

  &.${tabUnstyledClasses.selected} {
    background-color: ${white[50]};
    color: ${white[600]};
  }

  &.${buttonUnstyledClasses.disabled} {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const TabPanel = styled(TabPanelUnstyled)`
  width: 100%;
  font-family: IBM Plex Sans, sans-serif;
  font-size: 0.875rem;
`;

const TabsList = styled(TabsListUnstyled)`
  min-width: 320px;
  background-color: ${white[500]};
  border-radius: 8px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: space-between;
`;




export default function EmailTemplatesTab({ MOveValue }) {
  const { currentActiveTab, currentActiveSubTab } = useGlobalComponent(HasScreenPermissions(INFO?.EmailTemplatesList?.actionName) ? 0 : 1);

  const [value, setValue] = useState(-1);
  const location = useLocation();
  const [DisValue, setDisValue] = useState("");

  useEffect(() => {

    let count = 0;
    count = !HasScreenPermissions(INFO?.EmailTemplatesList?.actionName) ? count + 1 : count;
    count = !HasScreenPermissions(INFO?.EmailVendor?.actionName) ? count + 1 : count;
    setDisValue(count);


    setValue(MOveValue == true ? (!HasScreenPermissions(INFO?.EmailTemplatesList?.actionName) ? 0 : 1) : currentActiveSubTab);
  }, [currentActiveSubTab, location]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (

    <>
      <div className="row" >
        <TabsUnstyled value={value} onChange={handleChange} sx={{ backgroundColor: "#fff" }}>
          <TabsList sx={{ width: "340px" }} hidden={DisValue == 1}>
            <Tab hidden={HasScreenPermissions(INFO?.EmailTemplatesList?.actionName)}>Email Templates</Tab>
            <Tab hidden={HasScreenPermissions(INFO?.EmailVendor?.actionName)}>Email Vendor</Tab>
          </TabsList>
          <TabPanel value={0} hidden={HasScreenPermissions(INFO?.EmailTemplatesList?.actionName)}> <EmailTemplates /></TabPanel>
          <TabPanel value={1} hidden={HasScreenPermissions(INFO?.EmailVendor?.actionName)}><EmailVendor /></TabPanel>
        </TabsUnstyled>
      </div>

    </>
  );
}
